const AboutZeuss = () => {
  return (
    <>
      <section className="WhatPrcog TribeFuture pb-0" id="about">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h4>TRIBE: The Future of Digital Interaction</h4>
                <p>
                  One app for chat, video, shopping, and payments—powered by AI
                  for a seamless, secure experience.
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-right" data-aos-duration="2000"> */}
              <div className="image">
                <img src="/images/whatzeuss.png" alt="" />
              </div>
              {/* </div> */}
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-left" data-aos-duration="2000"> */}
              <div className="content">
                <img src="/images/quote.png" alt="" />
                <h4>
                  TRIBE is revolutionizing the way we interact digitally. By
                  combining AI and machine learning, we’ve created an all-in-one
                  platform that integrates chat, video sharing, shopping, and
                  payments into a single, seamless experience.
                </h4>
                <h4>
                  Our mission is simple: to eliminate app fatigue, enhance
                  security, and deliver personalized, intuitive solutions for
                  users worldwide. Join us as we redefine the future of digital
                  communication, commerce, and finance.
                </h4>
                {/* <div className="label">
                  <h5>Your Name</h5>
                  <span>Co-Founder of</span>
                  <label></label>
                </div> */}
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutZeuss;
